/*
 * DEV-15232 — Dynamic "N Day Supply" text on the product page.
 * The supply message is a static text block; this keeps it in sync with the
 * selected variant (e.g. 2 Month = 60, 3 Month = 90, 6 Month = 180 days, or the
 * "N Days" option names on Stage 3). No effect if the block or picker is absent.
 */
(function () {
  'use strict';

  var DAY_SUPPLY_RE = /\d+\s*Day Supply/i;

  function supplyDaysFromLabel(text) {
    if (!text) return null;
    var m = text.match(/(\d+)\s*months?/i);
    if (m) return parseInt(m[1], 10) * 30;
    m = text.match(/(\d+)\s*days?/i);
    if (m) return parseInt(m[1], 10);
    return null;
  }

  // Movimos la lógica principal directamente a update() para buscar
  // los elementos frescos del DOM cada vez que se ejecuta.
  function update() {
    var info = document.querySelector('.product-info');
    if (!info) return;

    var picker = info.querySelector('.variant-picker');
    if (!picker) return;

    var checked = picker.querySelector('input[type="radio"]:checked');
    if (!checked) return;

    var id = window.CSS && CSS.escape ? CSS.escape(checked.id) : checked.id;
    var label = document.querySelector('label[for="' + id + '"]');
    var textValue = (label ? label.textContent : checked.value) || null;

    var days = supplyDaysFromLabel(textValue);
    if (!days) return;

    var walker = document.createTreeWalker(info, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (DAY_SUPPLY_RE.test(node.nodeValue)) {
        var next = node.nodeValue.replace(DAY_SUPPLY_RE, days + ' Day Supply');
        if (next !== node.nodeValue) node.nodeValue = next;
        return;
      }
    }
  }

  function init() {
    // El tema dispara "variant:change". Este listener en document sobrevivirá
    // a los cambios del DOM.
    document.addEventListener('variant:change', update);
    
    // Delegación de eventos: escuchamos los cambios a nivel del documento
    // y verificamos si vienen del .variant-picker. Así no importa si
    // el HTML del picker es reemplazado por el tema.
    document.addEventListener('change', function (e) {
      if (e.target.closest('.variant-picker')) {
        window.requestAnimationFrame(update);
      }
    });

    // Ejecución inicial
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();